import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles((theme) => ({
  visibilityIcon: {
    width: 16,
    height: 16,
    color: theme.palette.text.fadeTextPrimary,
  },
}));
